var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateDataGrid',_vm._b({attrs:{"gridId":"PeUniformExamScheduleRoom"}},'TemplateDataGrid',_vm.gridParams,false))
}
var staticRenderFns = []

export { render, staticRenderFns }